import React, { useEffect, useRef, useState, forwardRef,useImperativeHandle } from "react";
import { loadModules } from "esri-loader";
import { FormGroup, Label, FormFeedback, Input, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from "reactstrap";
import PopoverItem from "../common/PRpopover";

export const WebMapView = forwardRef((props, ref) => {
  const mapRef = useRef(null);
    const [run, setRun] = useState(null);


  const addressFun = (address, x, y) => {

      if (address === "No address found.") address = "";
      props.updateLocationAddress(address, x, y, false);
  };



  useEffect(() => {
   // console.log(props);
 
      loadModules(
          [
              "esri/Map",
              "esri/views/MapView",
              //"esri/layers/FeatureLayer",
              //"esri/widgets/Search",
              "esri/widgets/Locate",
              "esri/Graphic",
              "esri/layers/GraphicsLayer",
              "esri/geometry/Extent",
              //"esri/tasks/GeometryService",
              //"esri/tasks/support/ProjectParameters",
              "esri/geometry/SpatialReference",
              "esri/geometry/Point",
              //"esri/layers/MapImageLayer",
              //"esri/renderers/support/jsonUtils",
              "esri/geometry/support/webMercatorUtils",
              //"esri/geometry/projection",
              //"dojo/_base/connect",
              //"dojo/domReady!"
          ],
          { css: true }
      ).then(
          ([
              ArcGISMap,
              MapView,
              //FeatureLayer,
              //Search,
              Locate,
              Graphic,
              GraphicsLayer,
              Extent,
              //GeometryService,
              //ProjectParameters,
              SpatialReference,
              Point,
              //MapImageLayer,
              //jsonUtils,
              webMercatorUtils,
              //projection,
              //connect
          ]) => {

             // console.log("props.extent", props.extent);
              var _extent = null;
              var  pointWkid = null;
              let centerPoint = null;

              if (props.extent!=null)
               _extent = Extent.fromJSON(props.extent);

              if (props.extent != null)
                  pointWkid = (_extent)["spatialReference"]["wkid"];
              else
                  pointWkid = 102100;

         

              if (props.sp != -1) {pointWkid = props.sp; }
  

              if (props.extent != null) {
                  //console.log("_extent.center","x=>"+_extent.center.x + "  y=>" + _extent.center.y.toFixed(4));
                  centerPoint = new Point({ "x": _extent.center.x.toFixed(4), "y": _extent.center.y.toFixed(4), "spatialReference": { "wkid": pointWkid } });
                  //console.log("centerPoint=>", centerPoint.x + " "+ centerPoint.y + " " + centerPoint.spatialReference.wkid);
              }

              //console.log("pointWkid=>", pointWkid);
        

              const map = new ArcGISMap({
                  basemap: "topo-vector",
                  spatialReference: new SpatialReference({ wkid: pointWkid })
              });
    
              var promise = new Promise((resolve, reject) => {
                  map.on('load', (e) => {
                      console.log(e);
                      resolve(e.layer.loaded)
                      reject("Something is wrong");
                  })
              });
              promise.then((e) => {
                  if (e) {
                      console.log("The layer has loaded");
                  }
              });


              const view = new MapView({
                  container: mapRef.current,
                  map: map,
                  zoom: 13
              });

             
           
                  const centerYRequest = {
                      inSR: pointWkid,
                      outSR: 102100,
                      geometries: JSON.stringify({ "geometryType": "esriGeometryPoint", "geometries": [centerPoint] }),
                      geometryUrl: props.geomUrl,
                      geometryToken: props.geomToken,
                      geomTokenRequired: props.geomTokenRequired
                  };

                  const requestOptionsCenter = {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(centerYRequest),
                  };

                  window
                      .fetch("GetExtentCenter", requestOptionsCenter)
                      .then((resp) => {
                          return resp.json();
                      })
                      .then((data) => {

                          try {
                              if (data.status === 0) {
                                  let value = data.value;

                                  let _wp = webMercatorUtils.xyToLngLat(value["x"], value["y"]);
                                  view.center = _wp;
                                //  console.log("_wp=>", _wp);

                              }
                          } catch { }

                      });
           

              const getAddressFromXY = (point) => {
                  //console.log("getAddressFromXY point=>", point);

                  props.loadDiv("show");
                  props.clearAlerts();
            let pointjson = { geometryType: "esriGeometryPoint", geometries: [point.toJSON()] };
            let mapWkid = ((point.toJSON())["spatialReference"])["wkid"];
                  //console.log("getAddressFromXY mapWkid=>", mapWkid);

            let addressFromXYRequest = {
                inSR: mapWkid,
                outSR: pointWkid,
                geometries: JSON.stringify(pointjson),
                geometryUrl: props.geomUrl,
                geometryt: props.geomToken,
                geocoderUrl: props.gcoderUrl,
                geocodert: props.gcoderToken,
                addressField: props.addressField,
                geomTokenRequired: props.geomTokenRequired,
                gcoderTokenRequired: props.gcoderTokenRequired,
                longitude: point.longitude,
                latitude: point.latitude

            };
      
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(addressFromXYRequest),
            };

            window
                .fetch("GetAddressFromXY", requestOptions)
                .then((resp) => {
                    return resp.json();
                })
                .then((data) => {
                  
                    try {
                        if (data.status === 0) {

                            var address = data.value;
 
                            drawPoint(point.longitude, point.latitude);

                            let location = data.location;
                            //console.log("address=>", address);
                            //console.log("location=>", location);
                            //console.log("point=>", point);

                            showPopup(address, point, location.x, location.y);
                           
                            setTimeout(() => {
                                view.takeScreenshot(options).then(function (screenshot) {
                                setTimeout(() => {
                                    props.saveScreenshot(screenshot.dataUrl);
                                }, 500);
                                });

                                var pixelRatio = 2;

                                view.takeScreenshot({
                                width: view.width * pixelRatio,
                                height: view.height * pixelRatio,
                                });
                            }, 500);
                            props.loadDiv("hide");

                        } else {
                            let location = data.location;
                            showPopup("No address found.", point, location.x, location.y);
 
                            props.loadDiv("hide");
                        }
                    } catch { props.loadDiv("hide");}
                    
                });
        }

 

              var graphicsLayer = new GraphicsLayer();
            
              map.add(graphicsLayer);
      

              function showPopup(address, pt, x, y) {
              
          view.popup.open({
            title:
              +Math.round(pt.longitude * 100000) / 100000 +
              "," +
              Math.round(pt.latitude * 100000) / 100000,
            content: address,
            location: pt,
          });
              
                  addressFun(address, x, y);  
        }



        view.on("click", function (evt) {
      
          //  search.clear();
            view.popup.clear();
  
            getAddressFromXY(evt.mapPoint);

        });



        var locate = new Locate({
          view: view,
          useHeadingEnabled: false,
          goToOverride: function (view, options) {
            options.target.scale = 1800; // Override the default map scale
            return view.goTo(options.target);
          },
        });

        view.ui.add(locate, "top-left");


 

        var options = {
          width: 400,
          height: 200,
          format: "jpg",
          ignoreBackground: false,
        };


      function drawPoint(longitude, latitude) 
      {
      
          graphicsLayer.removeAll();
          var point = {
            type: "point",
            longitude: longitude,
            latitude: latitude,
          };

          var simpleMarkerSymbol = {
            type: "simple-marker",
            color: [226, 119, 40], // orange
            outline: {
              color: [255, 255, 255], // white
              width: 1,
            },
          };

          var pointGraphic = new Graphic({
            geometry: point,
            symbol: simpleMarkerSymbol,
          });

          graphicsLayer.add(pointGraphic);
         // view.centerAndZoom(point, 12);
          let _wp = webMercatorUtils.xyToLngLat(longitude, latitude);
          view.center = _wp;
          view.zoom = props.mapZoom;//15;
        }

              var promise =
                  view.when(function () {
                   
                      restoreLocation();
                      // All the resources in the MapView and the map have loaded. Now execute additional processes
                  }, function (error) {
                      // Use the errback function to handle when the view doesn't load properly
                      console.log("The view's resources failed to load: ", error);
                  });

//Restore selected location begin
              const restoreLocation = () => {
                  try {
                  if (
                      props.fstate.coordinatesx &&
                      props.fstate.coordinatesx.value &&
                      props.fstate.coordinatesx.value.toString() !== "" &&
                      props.fstate.coordinatesy &&
                      props.fstate.coordinatesy.value &&
                      props.fstate.coordinatesy.value.toString() !== ""
                  ) {
                      props.loadDiv("show");

                      

                          var centerPoint2 = new Point({ "x": props.fstate.coordinatesx.value.toFixed(4), "y": props.fstate.coordinatesy.value.toFixed(4), "spatialReference": { "wkid": pointWkid } });
                          const centerYRequest2 = {
                              inSR: pointWkid,
                              outSR: 102100,
                              geometries: JSON.stringify({ "geometryType": "esriGeometryPoint", "geometries": [centerPoint2] }),
                              geometryUrl: props.geomUrl,
                              geometryToken: props.geomToken,
                              geomTokenRequired: props.geomTokenRequired
                          };

                      const requestOptionsCenter2 = {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(centerYRequest2),
                      };

                      window
                          .fetch("GetExtentCenter", requestOptionsCenter2)
                          .then((resp) => {
                              return resp.json();
                          })
                          .then((data) => {

                              try {
                                  if (data.status === 0) {
                                      let value = data.value;

                                      let _wp = webMercatorUtils.xyToLngLat(value["x"], value["y"]);

                                      view.center = _wp;
                                      drawPoint(
                                          _wp[0],
                                          _wp[1]
                                      );

                                      view.goTo(graphicsLayer.graphics);
                                      view.watch("updating", async (val) => {
                                          if (!val) {

                                              var options = {
                                                  width: 400,
                                                  height: 200,
                                                  format: "jpg",
                                                  ignoreBackground: false,
                                              };

                                              var pixelRatio = 2;

                                              view.takeScreenshot({
                                                  width: view.width * pixelRatio,
                                                  height: view.height * pixelRatio,
                                              });

                                              view.takeScreenshot(options).then(function (screenshot) {
                                                  props.saveScreenshot(screenshot.dataUrl);
                                                  props.loadDiv("hide");


                                              });
                                          }
                                      });

                                      view.popup.open({
                                          title:
                                              +Math.round(_wp[0] * 100000) / 100000 +
                                              "," +
                                              Math.round(_wp[1] * 100000) / 100000,
                                          content: props.fstate.problemLocation.value,
                                          location: _wp,
                                      });


                                  }
                              } catch { }

                          });

                

                      }

                  } catch (e) {
                      console.log(e);
                      props.loadDiv("hide");
                  }
              }


              //if (run) {
              //    console.log(run);
              //}


        return () => {      
            if (view) {
            // destroy the map view
            view.container = null;
          }
        };
      }
    );

  // console.log(mapRef); 
//  setTimeout(() => {
//  props.getMapRef(mapRef,mp);
//}, 5000);


//  },[]);
  }, [props.fstate.maprefresh.value, props.fstate.coordinatesx.value,run]);


    return (
      <>
            {props && props.fstate && props.fstate.problemLocation && props.fstate.problemLocation.disable ? (
                ""
            ) : (
                    <FormGroup>
                        <Label
                            className={
                                props.fstate.problemLocation.fontWeight ? "label-font" : ""
                            }
                        >
                            {props.translate(
                                props.lang,
                                props.fstate.problemLocation.label
                            )}{" "}
                            {!props.fstate.problemLocation.required ? (
                                <span className="colorred">
                                    {props.translate(props.lang, "optionalSign")}
                                </span>
                            ) : (
                                    ""
                                )}
                        </Label>
                        <PopoverItem
                            elem={props.fstate.problemLocation}
                            translate={props.translate}
                            lang={props.lang}
                        />

                        <ListGroup className="flex-select1">
                          
                                <Input
                                    key={props.fstate.problemLocation.name}
                                    type="input"
                                    autoComplete="off"
                                    name={props.fstate.problemLocation.name}
                                    id={props.fstate.problemLocation.name}
                                    placeholder={props.fstate.problemLocation.placeholder ? props.translate(props.lang, props.fstate.problemLocation.placeholder) : ""}
                                    value={props.fstate.problemLocation.valueDesc}
                                    valid={props.fstate.problemLocation.status === 0}
                                    invalid={props.fstate.problemLocation.status === 1}
                                    maprefresh={props.maprefresh}

                                onChange={(e) => {
                                        props.getAddreses(e);
                                    }}
                                />
                              
                            {props.gisAddreses?
                                <div className="listAddress stack-top">
                                {props.gisAddreses.map((a, index) => (
                                    <div className="flex-select-list-item" key={props.fstate.problemLocation.name + index + "div"}>
                                        <ListGroupItem
                                            tag="button"
                                            action
                                            key={props.fstate.problemLocation.name + index + "el"}
                                            onClick={(e) => {
                                                props.clearAlerts();
                                                props.fstate.problemLocation.valueDesc = a.address;


                                                props.updateLocationAddress(a.address, a.location.x, a.location.y, true, props.extent);
                                                //let _wp = webMercatorUtils.lngLatToXY(a.location.x, a.location.y);
                                                //console.log("_wp==>", _wp);
                                                setRun(a);
                                            }}>
        
                                            <ListGroupItemText>{a.address} </ListGroupItemText>
                                        </ListGroupItem>
                                    </div>
                                ))}
                            </div>
                                :""}
                        </ListGroup>

                        <FormFeedback valid></FormFeedback>
                        <FormFeedback>
                            {props.fstate.problemLocation.errorlabel && props.fstate.problemLocation.errorlabel.length > 0
                                ? props.translate(props.lang, props.fstate.problemLocation.label) + " " + props.translate(props.lang, "isRequired") +
                                " " +
                                (props.errmsg ? props.translate(props.lang, props.errmsg) : "")
                                : ""}
                        </FormFeedback>
                    </FormGroup>
                )}     
                
            
            <div className="webmap" ref={mapRef} id="map"  /> 
 
    </>
  );
});
